(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLicRegenerarService', ReporteEvaluativoLicRegenerarService);

    ReporteEvaluativoLicRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoLicRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteLic:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteLicregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
